import { SearchContext } from '~/components/SearchBuilder/utils/searchUtils';
import TextField from '~/components/TextField';

const ValueText = ({ className, value, onChange }) => {
  const { disabled } = useContext(SearchContext);
  return (
    <TextField
      disabled={disabled}
      variant="outlined"
      FormControlProps={{ className }}
      value={value}
      placeholder="Enter a value"
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

ValueText.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

export default ValueText;
